<template>
  <v-dialog v-model="loading" persistent max-width="290">
    <v-card>
      <v-card-text>
        <h2 class="text-xs-center">Por favor espere.</h2>
        <h3 class="text-xs-center">Procesando Información...</h3>
        <v-flex class="text-xs-center" py-3>
          <v-progress-circular
            indeterminate
            color="#466EA5"
            :size="50"
          ></v-progress-circular>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["loading"])
  }
};
</script>
